import * as React from 'react'
import { Button } from '@deepguide-ai/ui/button'
import { X } from 'lucide-react'
import { cn } from '@/lib/utils'

interface SettingsPopoverHeaderProps {
  title: string
  onClose: () => void
}

export function SettingsPopoverHeader({
  title,
  onClose,
}: SettingsPopoverHeaderProps) {
  return (
    <div className='flex items-center justify-between'>
      <h3 className='text-foreground text-sm leading-5 font-semibold'>
        {title}
      </h3>
      <Button
        type='button'
        variant='ghost'
        size='menuAction'
        onClick={onClose}
        className='text-muted-foreground'
      >
        <X className='h-4 w-4' />
      </Button>
    </div>
  )
}

interface SettingsFieldProps {
  label: React.ReactNode
  description?: React.ReactNode
  children: React.ReactNode
  className?: string
  htmlFor?: string
}

interface SettingsToggleProps {
  label: React.ReactNode
  children: React.ReactNode
  className?: string
}

export function SettingsToggle({
  label,
  children,
  className,
}: SettingsToggleProps) {
  return (
    <div className={cn('flex items-center justify-between', className)}>
      <label className='text-muted-foreground text-xs leading-4'>{label}</label>
      {children}
    </div>
  )
}

export function SettingsField({
  label,
  description,
  children,
  className,
  htmlFor,
}: SettingsFieldProps) {
  return (
    <div className={cn('flex flex-col gap-2', className)}>
      <label
        htmlFor={htmlFor}
        className='text-foreground text-sm leading-5 font-medium'
      >
        {label}
      </label>
      {description && (
        <p className='text-muted-foreground text-sm leading-5'>{description}</p>
      )}
      {children}
    </div>
  )
}
